import Vue from "vue";
import VueRouter from "vue-router";
//import Assessments from "../views/Assessments";
import Assessment from "../views/Assessment";
//import Brokers from "../views/Brokers";
import Broker from "../views/Broker";
import ThankYou from "../views/ThankYou";
import Page404 from "../views/Page404";
//import SignIn from "../views/SignIn";
//import RegularInspections from "../views/RegularInspections";
//import WalkInspections from "../views/WalkInspections";
//import AddInspection from "../views/AddInspection";
//import Inspection from "../views/Inspection";
//import InspectionRevision from "../views/InspectionRevision";
//import InspectionHistory from "../views/InspectionHistory";
//import Start from "../views/Start";
//import AddWalkInspection from "../views/AddWalkInspection";
//import CampusReport from "../views/CampusReport";
//import CampusPDFReport from "../views/CampusPDFReport";
import BrokerRecord from "../views/Broker/components/BrokerRecord";

Vue.use(VueRouter);

const routes = [
  // {
  //     path: "/assessments",
  //     name: "Assessments",
  //     component: Assessments,
  // },
  {
    path: "/assessments/:id",
    name: "Assessment",
    component: Assessment
  },
  // {
  //     path: "/brokers",
  //     name: "Brokers",
  //     component: Brokers,
  // },
  {
    path: "/brokers",
    name: "Broker",
    component: Broker
  },
  {
    path: "/brokers/:brokerId",
    name: "BrokerRecord",
    component: Broker
  },
  {
    path: "/brokers/:brokerId/:recordId",
    name: "BrokerTripRecord",
    component: BrokerRecord
  },
  {
    path: "/thankyou",
    name: "ThankYou",
    component: ThankYou
  },
  {
    path: "/page404",
    name: "Page404",
    component: Page404,
    props: true,
  }
  // {
  //     path: "/",
  //     name: "Start",
  //     component: Start,
  // },
  // {
  //     path: "/regular-inspections",
  //     name: "RegularInspections",
  //     component: RegularInspections,
  // },
  // {
  //     path: "/campus-assessments",
  //     name: "WalkInspections",
  //     component: WalkInspections,
  // },
  // {
  //     path: "/campus-assessment/:action/:campusId/:step",
  //     name: "AddWalkInspection",
  //     component: AddWalkInspection,
  // },
  // {
  //     path: "/edit-campus-assessment/:step/:campusId",
  //     name: "AddWalkInspection",
  //     component: AddWalkInspection,
  // },
  // {
  //     path: "/add-inspection",
  //     name: "AddInspection",
  //     component: AddInspection,
  // },
  // {
  //     path: "/inspection/:inspectionId/:page",
  //     name: "Inspection",
  //     component: Inspection,
  // },
  // {
  //     path: "/revision/:inspectionId",
  //     name: "InspectionRevision",
  //     component: InspectionRevision,
  // },
  // {
  //     path: "/inspection-history/:inspectionId",
  //     name: "InspectionHidtory",
  //     component: InspectionHistory,
  // },
  // {
  //     path: "/campus-assessments/:campusId/:step",
  //     name: "CampusReport",
  //     component: CampusReport,
  // },
  // {
  //     path: "/campus-assessment/create-report/:campusId",
  //     name: "CampusPDFReport",
  //     component: CampusPDFReport,
  // },
];

const router = new VueRouter({
  mode: !window.location.href.includes("localhost") ? "history" : "hash",
  base: "/",
  routes
});

export default router;
